import { render, staticRenderFns } from "./MdTitleRegInfo.vue?vue&type=template&id=5395b8da&"
import script from "./MdTitleRegInfo.vue?vue&type=script&lang=js&"
export * from "./MdTitleRegInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports